module.exports = __webpack_public_path__ + "static/img/icon_messages@2x.6eb2fcf7.png";